module.exports = {
	"ha": "nha",
	"id": 5.5,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by Age Category and MSM Status, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "50%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "50%",
				"height": "50%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -100,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#043f61"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0c4250"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0d4440"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#09472e"
					},
					{
						"y": 20,
						"dataLabels": {
							"enabled": false,
							"format": "1"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#043f61"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0c4250"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0d4440"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#09472e"
					},
					{
						"y": 20,
						"dataLabels": {
							"enabled": false,
							"format": "1"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#043f61"
					},
					{
						"y": 71.42857142857143,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0c4250"
					},
					{
						"y": 71.42857142857143,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0d4440"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#09472e"
					},
					{
						"y": 28.57142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.15384615384616,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#043f61"
					},
					{
						"y": 76.92307692307693,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#0c4250"
					},
					{
						"y": 73.07692307692307,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0d4440"
					},
					{
						"y": 69.23076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#09472e"
					},
					{
						"y": 42.30769230769231,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#043f61"
					},
					{
						"y": 70,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0c4250"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0d4440"
					},
					{
						"y": 20,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#09472e"
					},
					{
						"y": 20,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#043f61"
					},
					{
						"y": 84,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0c4250"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#0d4440"
					},
					{
						"y": 64,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#09472e"
					},
					{
						"y": 24,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "48"
						},
						"color": "#043f61"
					},
					{
						"y": 89.58333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "43"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.41666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "41"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.75,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#09472e"
					},
					{
						"y": 18.75,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "87"
						},
						"color": "#043f61"
					},
					{
						"y": 90.80459770114942,
						"dataLabels": {
							"enabled": false,
							"format": "79"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.50574712643679,
						"dataLabels": {
							"enabled": false,
							"format": "77"
						},
						"color": "#0d4440"
					},
					{
						"y": 82.75862068965517,
						"dataLabels": {
							"enabled": false,
							"format": "72"
						},
						"color": "#09472e"
					},
					{
						"y": 41.37931034482759,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 45.45454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#043f61"
					},
					{
						"y": 45.45454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0c4250"
					},
					{
						"y": 45.45454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0d4440"
					},
					{
						"y": 36.36363636363637,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#09472e"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#043f61"
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#09472e"
					},
					{
						"y": 58.333333333333336,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#043f61"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0c4250"
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0d4440"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#09472e"
					},
					{
						"y": 33.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 91.83673469387756,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#043f61"
					},
					{
						"y": 71.42857142857143,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#0c4250"
					},
					{
						"y": 67.3469387755102,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#0d4440"
					},
					{
						"y": 63.26530612244898,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#09472e"
					},
					{
						"y": 40.816326530612244,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -66.66666666666667,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -66.66666666666667,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.8461538461538436,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.888888888888886,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -60,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.761904761904767,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -62.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.416666666666663,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.651162790697672,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.512195121951216,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -72.72727272727273,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.195402298850574,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.5316455696202556,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.493506493506496,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -54.54545454545454,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -100,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.181818181818176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -44.44444444444444,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -8.163265306122447,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.714285714285716,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.060606060606055,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.483870967741936,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=5"
			},
			{
				"x": 9,
				"text": "30-39<br>n=5"
			},
			{
				"x": 15,
				"text": "40-49<br>n=7"
			},
			{
				"x": 21,
				"text": ">=50<br>n=26"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=10"
			},
			{
				"x": 34,
				"text": "30-39<br>n=25"
			},
			{
				"x": 40,
				"text": "40-49<br>n=48"
			},
			{
				"x": 46,
				"text": ">=50<br>n=87"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=11"
			},
			{
				"x": 59,
				"text": "30-39<br>n=12"
			},
			{
				"x": 65,
				"text": "40-49<br>n=15"
			},
			{
				"x": 71,
				"text": ">=50<br>n=49"
			}
		],
		"dataTable": {
			"MSM:<30": [
				5,
				5,
				4,
				4,
				3,
				1
			],
			"MSM:30-39": [
				5,
				5,
				3,
				3,
				3,
				1
			],
			"MSM:40-49": [
				7,
				7,
				5,
				5,
				4,
				2
			],
			"MSM:>=50": [
				26,
				25,
				20,
				19,
				18,
				11
			],
			"Non-MSM:<30": [
				10,
				10,
				7,
				5,
				2,
				2
			],
			"Non-MSM:30-39": [
				25,
				25,
				21,
				20,
				16,
				6
			],
			"Non-MSM:40-49": [
				48,
				48,
				43,
				41,
				33,
				9
			],
			"Non-MSM:>=50": [
				87,
				87,
				79,
				77,
				72,
				36
			],
			"Unknown:<30": [
				11,
				5,
				5,
				5,
				4,
				0
			],
			"Unknown:30-39": [
				12,
				12,
				10,
				10,
				10,
				7
			],
			"Unknown:40-49": [
				15,
				15,
				12,
				11,
				9,
				5
			],
			"Unknown:>=50": [
				49,
				45,
				35,
				33,
				31,
				20
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_5_5.json
// module id = 272
// module chunks = 0